<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
      @click:outside="dialog = false"
    >
      <!-- eslint-disable-next-line -->
      <template #activator="{ on: dialog, attrs}">
        <v-tooltip top>
          <template #activator="{ on: tooltip}">
            <v-btn
              color="green"
              outlined
              v-bind="attrs"
              class="mr-4"
              v-on="{...tooltip, ...dialog}"
            >
              <v-icon>mdi-calendar-search</v-icon>
            </v-btn>
          </template>
          <span>Domainsanzeige filtern</span>
        </v-tooltip>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Bitte wählen Sie nur das Startdatum</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-date-picker
                  v-model="dates"
                  range
                  :min="minStart"
                  no-title
                  :first-day-of-week="1"
                  locale="de-de"
                  full-width
                  flat
                  class="elevation-0"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-col class="d-flex justify-end">
            <v-btn
              color="green"
              outlined
              class="my-2"
              @click="selectAllDate"
            >
              Select All
            </v-btn>
            <v-col class="d-flex justify-end" />
            <v-btn
              color="green"
              outlined
              class="my-2"
              @click="selectThisMonth"
            >
              This Month
            </v-btn>
            <v-col class="d-flex justify-end" />
            <v-btn
              color="green"
              outlined
              class="my-2"
              @click="onSave"
            >
              Anpassen
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    component: 'DomainRangeSetting',
    data () {
      return {
        dialog: false,
        dates: [],
      }
    },
    computed: {
      minStart () {
        return new Date('2020-01-01').toISOString().slice(0, 10)
      },
    },
    mounted () {
      this.selectThisMonth()
    },
    methods: {
      onSave () {
        // this.$store.dispatch('fetchAllDomains', this.date)
        this.$emit('change-date-setting', this.dates)
        this.dialog = false
      },
      selectThisMonth () {
        let startDate = new Date()
        let endDate = new Date()
        startDate.setDate(1)
        startDate = startDate.toISOString().slice(0, 10)
        endDate = endDate.toISOString().slice(0, 10)
        this.dates = [startDate, endDate]
      },
      selectAllDate () {
        this.dates = [process.env.VUE_APP_VOFFICEINITDATE, new Date().toISOString().slice(0, 10)]
      },
    },
  }
</script>
